enum EnumAppointmentSource {
    Myle_Calendar = 1,
    Myle_PatientProfile = 2,
    Portal = 3,
    IntegrationApi = 4,
    Myle_Auto = 5,
    Myle_PAList = 6,
    RVSQ = 7,
    Kiosk = 8,
    Myle_MedicalNote = 9,
    Unknown = 999
}

export { EnumAppointmentSource };
